// Centralized auth persistence helpers
// Keeps localStorage access in one place

export function normalizeUser(user) {
  if (!user || typeof user !== 'object') return user;
  const avatarUrl = user.avatarUrl || user.avatar?.url || user.avatar || null;
  const displayName = user.displayName || user.name || [user.firstName, user.lastName].filter(Boolean).join(' ') || (user.email ? user.email.split('@')[0] : undefined);
  return { ...user, avatarUrl, displayName };
}

export function persistAuth({ sessionId, user, roles }) {
  try {
    if (sessionId) {
      localStorage.setItem('token', sessionId);
    }
    if (user) {
      const normalizedUser = typeof user === 'object' ? normalizeUser(user) : user;
      localStorage.setItem('user', JSON.stringify(normalizedUser));
    }
    if (roles) {
      localStorage.setItem('roles', JSON.stringify(roles));
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[persistAuth] failed:', e);
  }
}

export function clearAuth() {
  try {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('roles');
    localStorage.removeItem('incarnated');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[clearAuth] failed:', e);
  }
}

export function setIncarnated(flag) {
  try {
    localStorage.setItem('incarnated', flag ? 'true' : 'false');
    if (typeof window !== 'undefined') {
      try {
        window.dispatchEvent(new CustomEvent('incarnated-changed', { detail: !!flag }));
      } catch {}
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[setIncarnated] failed:', e);
  }
}

export function getIncarnated() {
  try {
    return typeof window !== 'undefined' ? localStorage.getItem('incarnated') === 'true' : false;
  } catch { return false; }
}

export function clearIncarnated() {
  try {
    localStorage.removeItem('incarnated');
    if (typeof window !== 'undefined') {
      try { window.dispatchEvent(new CustomEvent('incarnated-changed', { detail: false })); } catch {}
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[clearIncarnated] failed:', e);
  }
}
